import $ from 'jquery';

export default function faqModule() {
  const searchElement = $('.faq');
  if (searchElement.length) {
    return import(/* webpackChunkName: "faq" */ '../faq')
      .then(({ default: FAQ }) => {
        const faq = new FAQ();
        return faq;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
